import { P, Strong } from '@ahmdigital/ui';

import constants from '../../../ahm-constants';

export default {
  description: (
    <P>
      You also get <Strong>70%</Strong> back at <Strong>your choice of recognised provider</Strong> on included dental
      services and many other services like <Strong>podiatry</Strong>, up to your annual limits.
    </P>
  ),
  getSellingPoints: () => [
    {
      description: 'up to your annual limit on included extras.',
      title: '70% back at your choice of recognised provider',
    },
    {
      description: 'Frames, prescription lenses and contact lenses included.',
      title: '100% back on optical',
    },
  ],
  upgrade: {
    cta: 'Get the best dental limits we offer with super extras',
    id: constants.PRODUCT.SUPER_EXTRAS,
    title: '',
  },
};
